(function () {
  'use strict';

  var MENU = '.header-menu';
  var ITEM = '.header-menu-item';
  var TRIGGER = 'a.menu-list__link, a.header-menu-item-wrapper';
  var PANEL = '.menu-list__submenu';
  var CLOSE_BTN = '.header-megamenu-close';
  var OPEN_CLASS = '[aria-expanded="true"]';

  /* ---------------------------------------------------------------- CSS -- */
  var css = [
    // Visible keyboard focus indicator inside the header/mega menu (2.4.7).
    '.header-section a:focus-visible,',
    '.header-section button:focus-visible {',
    '  outline: 2px solid #173C9C !important;',
    '  outline-offset: 2px;',
    '  border-radius: 2px;',
    '}'
  ].join('\n');
  var style = document.createElement('style');
  style.setAttribute('data-kef-a11y', 'megamenu');
  style.textContent = css;
  document.head.appendChild(style);

  /* ------------------------------------------------------------- helpers -- */
  function items() {
    return Array.prototype.slice.call(document.querySelectorAll(MENU + ' ' + ITEM));
  }
  function triggerOf(item) {
    return item.querySelector(TRIGGER);
  }
  function panelOf(item) {
    return item.querySelector(PANEL);
  }
  function openItem() {
    return document.querySelector(MENU + ' ' + ITEM + '[aria-expanded="true"]');
  }

  /* 1. Make panel content keyboard-reachable.
   * The theme hard-codes tabindex="-1" on every link in every panel. Closed
   * panels are visibility:hidden, so their links are excluded from the tab
   * order by CSS alone — the attribute is unnecessary and harmful. Strip it,
   * and keep it stripped if theme JS ever re-applies it. */
  function stripTabindex(root) {
    var nodes = (root || document).querySelectorAll(PANEL + ' [tabindex="-1"]');
    for (var i = 0; i < nodes.length; i++) nodes[i].removeAttribute('tabindex');
  }

  /* 2. Disclosure semantics on the four top-level triggers. */
  var uid = 0;
  function applySemantics() {
    items().forEach(function (item) {
      var trig = triggerOf(item);
      var panel = panelOf(item);
      if (!trig || !panel) return;
      if (!panel.id) panel.id = 'kef-megamenu-' + (++uid);
      if (trig.getAttribute('role') !== 'button') trig.setAttribute('role', 'button');
      if (trig.getAttribute('aria-haspopup') !== 'true') trig.setAttribute('aria-haspopup', 'true');
      if (trig.getAttribute('aria-controls') !== panel.id) trig.setAttribute('aria-controls', panel.id);
      var expanded = item.classList.contains(OPEN_CLASS) ? 'true' : 'false';
      if (trig.getAttribute('aria-expanded') !== expanded) trig.setAttribute('aria-expanded', expanded);
    });
    /* The theme renders a mouse-only close (×) <button> inside the trigger link —
     * invalid nested-interactive markup (4.1.2), and its click handler is dead on
     * the stock theme (clicking it closes nothing). Replace it with a decorative
     * <span> that keeps the visual × and give it a WORKING mouse close handler.
     * Keyboard and screen reader users get Escape + the trigger toggle instead,
     * so the span stays aria-hidden. */
    Array.prototype.forEach.call(document.querySelectorAll(MENU + ' ' + CLOSE_BTN), function (btn) {
      if (btn.tagName === 'BUTTON') {
        var span = document.createElement('span');
        span.className = btn.className;
        span.innerHTML = btn.innerHTML;
        span.setAttribute('aria-hidden', 'true');
        span.style.cursor = 'pointer';
        span.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();   // don't bubble to the trigger, or it double-toggles
          closeOpenMenu(false);
        });
        btn.parentNode.replaceChild(span, btn);
      }
    });
    var menu = document.querySelector(MENU);
    if (menu && !menu.hasAttribute('role')) {
      menu.setAttribute('role', 'navigation');            // 5. landmark
      menu.setAttribute('aria-label', 'Main menu');
    }

    /* 8. Cut screen-reader read-out length. Each product/category tile is a
     * link that contains BOTH a decorative image (alt="Muon") AND a visible
     * text label (<span class="menu-link-text">Muon</span>), so screen readers
     * announce every tile twice ("Muon, Muon"). The visible text is the real
     * label, so blank the image alt to mark it decorative — the tile is then
     * announced once. */
    Array.prototype.forEach.call(
      document.querySelectorAll(PANEL + ' a .menu-link-text'),
      function (label) {
        var link = label.closest('a');
        if (!link) return;
        var name = (label.textContent || '').trim().toLowerCase();
        if (!name) return;
        Array.prototype.forEach.call(link.querySelectorAll('img[alt]'), function (img) {
          // only neutralize when the alt duplicates the visible label
          if ((img.getAttribute('alt') || '').trim().toLowerCase() === name) {
            img.setAttribute('alt', '');
          }
        });
      }
    );
  }

  /* Close the open panel via the theme's own toggle (a full mouse-event
   * sequence on the active trigger — the theme ignores bare .click()),
   * then restore focus. */
  function closeOpenMenu(restoreFocus) {
    var item = openItem();
    if (!item) return false;
    var trig = triggerOf(item);
    if (trig) {
      ['mousedown', 'mouseup'].forEach(function (type) {
        trig.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true }));
      });
      trig.click();
      if (restoreFocus) trig.focus();
    }
    return true;
  }

  /* 3. Escape closes the menu and returns focus to the trigger. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    if (closeOpenMenu(true)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  /* 4. If focus moves outside the header while a panel is open, close the
   * panel (without stealing focus) so keyboard users are never focused on
   * content hidden behind the overlay. */
  document.addEventListener('focusin', function (e) {
    var item = openItem();
    if (!item) return;
    var header = item.closest('.header-container') || item.closest('header');
    if (header && !header.contains(e.target)) closeOpenMenu(false);
  });

  /* 7. Click outside the header closes the open panel (dead on the stock
   * theme). isTrusted guard: closeOpenMenu itself dispatches synthetic
   * clicks on the trigger, so only react to real user clicks. */
  document.addEventListener('click', function (e) {
    if (!e.isTrusted) return;
    var item = openItem();
    if (!item) return;
    var header = item.closest('.header-container') || item.closest('header');
    if (header && !header.contains(e.target)) closeOpenMenu(false);
  }, true);

  /* ------------------------------------------------ apply + keep in sync -- */
  function applyAll() {
    stripTabindex();
    applySemantics();
  }

  function start() {
    applyAll();
    var observer = new MutationObserver(function (muts) {
      var needsApply = false;
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.type === 'attributes') {
          if (m.attributeName === 'tabindex' &&
              m.target.getAttribute('tabindex') === '-1' &&
              m.target.closest && m.target.closest(PANEL)) {
            m.target.removeAttribute('tabindex');
          } else if (m.attributeName === 'class' &&
                     m.target.matches && m.target.matches(ITEM)) {
            needsApply = true;                            // open/close: sync aria-expanded
          }
        } else if (m.type === 'childList' && m.addedNodes.length) {
          needsApply = true;                              // header re-rendered
        }
      }
      if (needsApply) applyAll();
    });
    var scope = document.querySelector('.header-container') || document.body;
    observer.observe(scope, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['tabindex', 'class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();